module.exports = __webpack_public_path__ + "img/textos-estagio.932a6782.png";